// Document ready
$(() => {

  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }

        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');

          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }

            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Search input hiding
  // get current input
  const currentValue = $(".search__form input[name='q']").val();
  // return amount without *
  if ($(".search__form input[name='q']").length > 0) {
    $(".search__form input[name='q']").val(currentValue.replace('*', ''));
  }

  // Collection sorting

  const sortByEls = document.querySelectorAll('[data-sort-by]');

  if (sortByEls.length > 0) {
    sortByEls.forEach(sortByEl => {
      sortByEl.addEventListener('change', e => {
        const { target } = e;
        const sortValue = target.value;
        if (target) {
          // Set the query string and redirect
          const queryString = new URLSearchParams(document.location.search);
          queryString.set('sort_by', sortValue);
          window.location.search = queryString;
        }
      });
    });
  }


  $('body')
    .on('change', '#tag_filter', () => {
      $('[data-option-filter] input').prop('checked', false);
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#blog_filter', function () {
      const url = $(this).val();
      window.location = url;
    });

  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: ($('.content').offset().top),
    }, 500);
  });

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
  }

  $('body').on('mouseenter', '.icon-search', () => {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', () => {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', e => {
    const $this = $(e.currentTarget);
    $this.parent().submit();
  });

  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, { offset: '70%' });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, { offset: '70%' });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, { offset: '70%' });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, { offset: '70%' });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  window.utils.initializeTabs();
  window.accordion.init();

  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning }</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);

    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.product-list');
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('.product-list');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function processQuantity(data) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success(data) {
        const max = cartItem.max;
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).attr('max', max);

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      },
      error: function(error) {
        var errMsg = `<p class="err">${error.responseJSON.description}</p>`;
        cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .product-quantity-box`).append(errMsg);
        cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .product-quantity-box input`).val(parseInt(cartItem.quantity - 1));
        setTimeout(function() {
          cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .product-quantity-box .err`).remove();
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
              })
            }
          });
        }, 2000);
      }
    });
  }

  function updateCartItemQuantity(cartItem) {
    var removeProp = [];
    
    if((cartItem.type === 'Jerseys' || cartItem.type === 'Pants - Off-Road') && cartItem.jerseyName !== '' && cartItem.quantity == 0) {
      $.getJSON('/cart.js').done(function(cart) {
        
        var print_remove = cartItem.jerseyName;
        var keyArray = [];
        for(let x = 0; x < cart.items.length; x++) {
          if(cart.items[x].properties['Jersey Name'] === print_remove) {
            keyArray.push(cart.items[x].key);
          }
        }

        const lineItems = {
          updates: keyArray.reduce((acc, key) => {
            acc[key] = 0;
            return acc;
          }, {})
        };

        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: lineItems,
          dataType: 'json',
          success: function(data) {
            $.getJSON('/cart.js').done(function(cart) {
              setTimeout(function () {
                refreshCart(cart);
              })
            });
          },
          error: function(xhr, status, error) {
          console.error('Error updating cart:', error);
          }
        });
      });
    }
    else if (cartItem.print && cartItem.print !== '' && cartItem.quantity == 0) {
      if (cartItem.print && cartItem.print !== '' && cartItem.quantity == 0) {
        const lineID = cartItem.lineID;
        if (cartItem.print.includes('Combo')) {
          removeProp.push(lineID + 1, lineID + 2);
        } else {
          removeProp.push(lineID + 1);
        }
      }

      if (cartItem.jerseyName && cartItem.quantity == 0) {
        $.getJSON('/cart.js')
          .done(function(cart) {
            async function processRemoveProps() {
              for (let x = 0; x < removeProp.length; x++) {
                var index = removeProp[x] - 1;
                if (cart.items[index]) {
                  var key = cart.items[index].key;
                  var data = {
                    'id': key,
                    'properties': {
                      'Combo Id': cart.items[index].properties['Combo Id']
                    },
                  };
                  await removeProperties(data);
                } 
                else {
                  console.error('Invalid index:', removeProp[x]);
                }
              }
            }
  
            processRemoveProps()
              .then(function() {  
                var data = {
                  quantity: cartItem.quantity,
                  line: cartItem.lineID,
                };
                processLineItem(data);
              })
              .catch(function(error) {
                console.error('Error removing properties:', error);
              });
          })
          .fail(function(jqxhr, textStatus, error) {
            console.error('Error fetching cart data:', textStatus, error);
          });
  
          function removeProperties(data) {
            if (!data.properties || Object.keys(data.properties).length === 0) {
              data.properties["Combo Id"] = data.properties['Combo Id'];
            }
          
            return new Promise(function(resolve, reject) {
              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: data,
                success: function(response) {
                  resolve();
                },
                error: function(xhr, status, error) {
                  console.error('Error removing properties:', error);
                  reject(error);
                }
              });
            });
          }
      }
      else {
        var data = {
          quantity: cartItem.quantity,
          line: cartItem.lineID,
        };
        processLineItem(data);
      }
    }
    else if (cartItem.comboId !== '' && cartItem.quantity == 0) {
      $.getJSON('/cart.js').done(function(cart) {
        
        var combo_to_be_removed = parseInt(cartItem.comboId);
        var keyArray = [];

        for(let x = 0; x < cart.items.length; x++) {
          if(parseInt(cart.items[x].properties['Combo Id']) === combo_to_be_removed) {
            keyArray.push(cart.items[x].key);
          }
        }

        const lineItems = {
          updates: keyArray.reduce((acc, key) => {
            acc[key] = 0;
            return acc;
          }, {})
        };

        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: lineItems,
          dataType: 'json',
          success: function(data) {
            $.getJSON('/cart.js').done(function(cart) {
              setTimeout(function () {
                refreshCart(cart);
              })
            });
          },
          error: function(xhr, status, error) {
          console.error('Error updating cart:', error);
          }
        });
      });
    }
    else {
      var data = {
        quantity: cartItem.quantity,
        line: cartItem.lineID,
      };
      processLineItem(data);
    }

    function processLineItem(data) {
      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        success(data) {
          const max = cartItem.max;
          const cartItemsArray = data.items;
          const lineIDIndex = cartItem.lineID - 1;
          const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
          const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
          let initialQuantityTotal = 0;
          let apiQuantityTotal = 0;
          const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
  
          cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).attr('max', max);
  
          // Check if item has a "Buy X get Y" deal
          if ($quantityInputs.length > 1) {
            // Multiple inputs
  
            // Get all the quantities of same variants in the cart (including BOGO) in HTML
            $.each($quantityInputs, (_i, input) => {
              initialQuantityTotal += parseInt($(input).val());
            });
  
            // Get quantities from cart object returned from API
            cartItemsArray.forEach(item => {
              if (item.variant_id === cartItem.variantID) {
                apiQuantityTotal += item.quantity;
              }
            });
          } else {
            // Single input
            initialQuantityTotal = parseInt($quantityInputs.val());
            apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
          }
  
          // Checks to see if there is enough inventory to update to an increased amount
          if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
            if (apiQuantityTotal === 1) {
              itemsLeftText = window.PXUTheme.translation.one_item_left;
            } else {
              itemsLeftText = window.PXUTheme.translation.items_left_text;
            }
  
            $('.warning--quantity').remove();
  
            // Check if Buy one get one product
            if (totalCartItems < cartItemsArray.length) {
              if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
                // Refreshes cart if inventory is available
                cartItem.parentCartForm.submit();
              } else {
                refreshCart(data);
              }
            } else {
              const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
              cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
              cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
            }
          } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
            // Refreshes cart if inventory is available
            cartItem.parentCartForm.submit();
          } else {
            refreshCart(data);
          }
        },
        error: function(error) {
          var errMsg = `<p class="err">${error.responseJSON.description}</p>`;
          cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .product-quantity-box`).append(errMsg);
          cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .product-quantity-box input`).val(parseInt(cartItem.quantity - 1));
          setTimeout(function() {
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .product-quantity-box .err`).remove();
            $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success(cart) {
                setTimeout(function () {
                  refreshCart(cart);
                })
              }
            });
          }, 2000);
        }
      });
    }
  }

  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    $('.cart-count').empty();
    const $cartBtn = $('.cart-count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartAfterpayHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;
    let upsellDiscount = 0;
    let freeGiftValue = 0;

    $cartForm.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    $cartBtn.text(cart.item_count);

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {      
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0;
      let saving = 0;

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';
        let triggerMatch = false; 

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        if (item.properties) {
          var isFreeItem = false;
          var newPrice = item.price;
          var discountValue = 0;
          var isUpsell = false;
          var herokuApp = false;
          var giftValue = 0;
          var print_for = '';
          var jersey_name = '';
          var jersey_number = '';
          var combo_id = '';

          $.each(item.properties, (title, value) => {
            if (value) {
              if(title == 'free_item' && value == 'true') {
                isFreeItem = true;
                freeGiftValue += giftValue + parseFloat(item.price);
              }
              if(title == 'Price') {
                isUpsell = true;
                newPrice = (parseFloat(value) * 100.0);
              }
              if(title == 'Trigger') {
                const trigger = value;
                if (cart.items.some(item => item.title.includes(trigger))) {
                  triggerMatch = true;
                }
              }
              if(title == 'Discount') {
                herokuApp = true;
                discountValue = (parseFloat(value) * 100.0)
                upsellDiscount += discountValue * item.quantity;
              }
              if(title == 'Print For') {
                print_for = value;
              }
              if(title == 'Jersey Name') {
                jersey_name = value;
              }
              if(title == 'Jersey Number') {
                jersey_number = value;
              }
              if(title == 'Combo Id') {
                combo_id = value;
              }
            }
          });

          if(freeGiftValue > 0) {
            herokuApp = true;
          }
        }
        
        cartItemsHTML += `<li class="mini-cart__item" data-key="${item.key}" data-print="${print_for}" data-jerseyname="${jersey_name}" data-jerseynumber="${jersey_number}" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-type="${item.product_type}" data-title="${item.title}" data-combo-id="${combo_id}">`
          + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">'
              + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        var vendor = item.vendor;
        var title = item.title;

        if(item.title.indexOf('-') > -1) {
          vendor = item.title.split('-')[0];
          title = item.title.replace(vendor, '').replace('- ', '');
        }
        
        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">
          <p class="product-vendor uppercase font-bold">${vendor}</p>
          <p class="product-title">${title}</p>
        </a>`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `/products/${item.handle}.js`,
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price && productData.compare_at_price > productData.price) {
              productHasSale = true;
              productCompareAtPrice = productData.compare_at_price;
              productFinalPrice = productData.price;
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        if(herokuApp) {
          $('.add_to_cart[name="checkout"]').attr('id', 'heroku-checkout');
        }
        else {
          $('.add_to_cart[name="checkout"]').removeAttr('id', 'heroku-checkout');
        }

        if(isUpsell) {
          const itemPrice = `${window.Shopify.formatMoney(newPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
          saving = discountValue * item.quantity;
          totalSaving = saving + totalSaving;
        }
        else {
          if (productHasSale === true) {
            // puts the slash through the old item price
            const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

            // Total savings
            saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
            totalSaving = saving + totalSaving;
          } else if (item.price > item.final_price) {
            // puts the slash through the old item price
            const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
          } else {
            const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
            if(isFreeItem) {
              cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
            }
            else {
              if (item.price > 0) {
                cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
              } else {
                cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
              }
            }
          }
        }

        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }
        
        if(!isFreeItem) {
          let hideTrash = 'flex';
          let hideMinus = 'hidden';
          if(item.quantity >= 2) {
            hideTrash = 'hidden';
            hideMinus = 'block';
          }

          cartItemsHTML += `<div class="product-quantity-box">`;
          cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus">';
          cartItemsHTML += `<span class="icon-minus ${hideMinus}"></span><span class="icon-trash ${hideTrash}"><img src="//amawarehouse.com.au/cdn/shop/t/156/assets/icon-trash.svg?v=10066701290031712681748307315" alt="Remove Item" width="15" height="15"/></span></span>`;
          cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
          cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
          cartItemsHTML += '</div></div></div>';
        }

        if (isUpsell && !triggerMatch) {
          const updates = {
            updates: {
              [item.key]: 0
            }
          };

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: updates,
            dataType: 'json',
            success: function(data) {
              $.ajax({
                url: '/cart.js',
                dataType: 'json',
                cache: false,
                success(cart) {
                  setTimeout(function () {
                    refreshCart(cart);
                  })
                }
              })
            },
            error: function(xhr, status, error) {
            console.error('Error updating cart:', error);
            }
          });
        }
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      // var cart_price = cart.total_price - upsellDiscount;
      var cart_price = cart.total_price - (upsellDiscount + freeGiftValue);

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;

      cartAfterpayHTML += `<span class="">Or 4 installments of ${window.Shopify.formatMoney(cart_price / 4, $('body').data('money-format'))}</span> with <img src="//amawarehouse.com.au/cdn/shop/t/156/assets/icon-afterpay.svg?v=97660303937512046891748307317" alt=" Afterpay" width="85" height="25">`;

      if (totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">- ${window.Shopify.formatMoney((totalSaving), $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_savings').html(cartSavingsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_afterpay').html(cartAfterpayHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }

    updateProgressBar(cart_price);
    tagBasedGift();
  }

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
      max: $(this).parents('[data-cart-item]').data('max'),
      title: $(this).parents('[data-cart-item]').data('title'),
      print: $(this).parents('[data-cart-item]').data('print'),
      jerseyName: $(this).parents('[data-cart-item]').data('jerseyname'),
      jerseyNumber: $(this).parents('[data-cart-item]').data('jerseynumber'),
      comboId: $(this).parents('[data-cart-item]').data('combo-id'),
      type: $(this).parents('[data-cart-item]').data('type'),
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      var isJerseyPrinting = false;
      var show_jersey_printing = false;
      if($(this).hasClass('jersey-printing') && show_jersey_printing) {
        isJerseyPrinting = true; 
      }

      if(isJerseyPrinting) {
        showPopup();
      }
      else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
          },
          success() {
            $addToCartBtn.find('.checkmark').addClass('checkmark-active');

            window.setTimeout(() => {
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
              $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            }, 1000);

            // Upsell Here
            getUpsell();

            $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success(cart) {
                setTimeout(function () {
                  
                  refreshCart(cart);

                  $('#shopify-section-sidecart .cart-container').addClass('active_link');
                  
                  if ($('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                  }

                  if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                  } else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                  } else {
                    $('.top-bar .cart-container').addClass('active_link');
                  }

                  if (window.PXUTheme.media_queries.xlarge.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                      // $('body').addClass('blocked-scroll');
                    } else {
                      // $('body').addClass('blocked-scroll');
                    }

                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                    }
                  }
                }, 500);
              },
            });
          },
          error(XMLHttpRequest) {
            let response = eval(`(${XMLHttpRequest.responseText})`);
            response = response.description;
            $('.warning').remove();

            const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
            $addToCartForm.append(warning);
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
            $('.product-moving form .purchase-details__buttons').append(warning);
            $('.product-moving .moving-ajax-submit').removeAttr('disabled').removeClass('disabled');
            $('.product-moving .moving-ajax-submit').find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');

          },
        });
      }
      $('#cnc-results-container #cnc-outlets').empty();
      setTimeout(function() {
        $('#cnc-container .btn').click();
      }, 500)
      return false;
    });
  }

  window.productPage.productSwatches();



  function updateProgressBar(cart_total) {
    var cart_total = cart_total;
    if(cart_total == 0) {
      $.getJSON('/cart.js', function(cart) {
        var upsellDiscount = 0;
        $.each(cart.items, (index, item) => {
          if (item.properties) {
            $.each(item.properties, (title, value) => {
              if (value) {
                if(title == 'Discount') {
                  var discountValue = (parseFloat(value) * 100.0);
                  upsellDiscount += discountValue;
                }
              }
            });
          }
        });

        var updated_cart_total = (cart.total_price - upsellDiscount);
        processProgressBar(updated_cart_total);
      });
    }
    else {
      processProgressBar(cart_total);
    }
  }

  function processProgressBar(cart_total) {
    var milestones = document.getElementById('sidecart_promo').dataset.promo;
    var currentValue = parseFloat(cart_total) / 100.0;  

    const milestonesArray = JSON.parse(milestones);
    const totalMilestones = milestonesArray.length
    const milestoneLabelsZero = '<div class="milestone-container" style="left:0;"><div class="milestone-amount">$0</div><div class="milestone-line"></div><div class="milestone-label"></div></div>';
    var remainingAmount = [];
    const milestoneLabels = milestonesArray.map((milestone, index) => {
      const milestonePercentage = parseInt((100 / totalMilestones) * (index + 1));
      remainingAmount.push(parseFloat(milestone.target - currentValue));
      return `<div class="milestone-container" style="left:${milestonePercentage}%;">
        <div class="milestone-amount">$${milestone.target}</div>
        <div class="milestone-line"></div>
        <div class="milestone-label">${milestone.name}</div>
      </div>`;
    });

    const allMilestoneLabels = [milestoneLabelsZero].concat(milestoneLabels);
    document.getElementById("milestone-labels").innerHTML = allMilestoneLabels.join('');

    var milestoneText = document.getElementById('milestone-text');
    var parsedMilestones = JSON.parse(milestones);
    

    var nearestMilestone = parsedMilestones.find(function(milestone) {
      return currentValue < parseInt(milestone.target);
    });

    if(currentValue > parsedMilestones[parsedMilestones.length - 1].target) {
      var milestone_name = ' a ' + parsedMilestones[parsedMilestones.length - 1].name;
      if(parsedMilestones[parsedMilestones.length - 1].name == 'Free Shipping' || parsedMilestones[parsedMilestones.length - 1].name== 'FREE SHIPPING') {
        milestone_name = parsedMilestones[parsedMilestones.length - 1].name;
      }

      milestoneText.innerHTML = "You've unlocked <strong>" + parsedMilestones[parsedMilestones.length - 1].name + "</strong>";
      document.getElementById("progress-bar").style.width = "100%";
    }
    else {
      
      if (!nearestMilestone) {
        var milestone_name = ' a ' + nearestMilestone.name;
        if(nearestMilestone.name == 'Free Shipping' || nearestMilestone.name == 'FREE SHIPPING') {
          milestone_name = nearestMilestone.name;
        }
        milestoneText.innerHTML = "You've unlocked <strong>" + nearestMilestone.name + "</strong>";
      } else {
        var remainingAmount = window.Shopify.formatMoney(parseFloat(nearestMilestone.target - currentValue) * 100.0, $('body').data('money-format'))
        var milestone_name = ' a ' + nearestMilestone.name;
        if(nearestMilestone.name == 'Free Shipping' || nearestMilestone.name == 'FREE SHIPPING') {
          milestone_name = nearestMilestone.name;
        }
        milestoneText.innerHTML = "<span>Add " + remainingAmount + " More</span> & get <strong>" + milestone_name + "</strong>";
  
        var closeTarget = nearestMilestone.target;
        var closePercent = (currentValue / closeTarget) * 100

        var index = parsedMilestones.findIndex(function(obj) {
          return obj.target === closeTarget;
        });

        var percentage = (closePercent * (100 / parsedMilestones.length ) *  parseInt(index + 1)) / 100;
        document.getElementById("progress-bar").style.width = percentage + "%";
      }
    }

    parsedMilestones.forEach(function(milestone) {
      var target = parseInt(milestone.target);
      var reward = milestone.reward;
      var name = milestone.name;
      var product = milestone.product;
      var productId = milestone.product_id;

      var banner = document.querySelector('.free-gift-banner[data-reward="' + name + '"] .free-gift-text p');
      if (reward === 'free_gift') {
        if (currentValue >= target) {

          var milestone_name = ' a ' + name;
          if(name == 'Free Shipping' || name == 'FREE SHIPPING') {
            milestone_name = name;
          }
          banner.innerHTML = `<p>You've unlocked a <strong>${milestone_name}</strong></p>`;
          $.getJSON('/cart.js', cart => {
            const freeItemAlreadyInCart = cart.items.some(item => item.properties?.promo === name);
            if (!freeItemAlreadyInCart) {
              addFreeGift(productId, name);
            }
          });
        } 
        else {
          var remaining = (target - currentValue).toFixed(2);
          var milestone_name = ' a ' + name;
          if(nearestMilestone.name == 'Free Shipping' || nearestMilestone.name == 'FREE SHIPPING') {
            milestone_name = name;
          }
          banner.innerHTML = `<p>Add $${remaining} more & get ${milestone_name}</p>`;
          $.getJSON('/cart.js', cart => {
            const freeItemAlreadyInCart = cart.items.some(item => item.properties?.promo === name);
            if (freeItemAlreadyInCart) {
              removeFreeGift(productId);
            }
          });
        }
      }
    });
  }

  function addFreeGift(productId, milestone_name) {
    var free_id = productId;
    var data = {
      items: [{
        id: free_id,
        quantity: 1,
        properties: {
          free_item: true,
          promo: milestone_name
        }
      }]
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(cart) {
        $.getJSON('/cart.js', function(cart) {
          refreshCart(cart);
        });
      }
    });
  }

  function removeFreeGift(productId) {
    var data = {
      id: productId,
      quantity: 0
    };
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: data,
      success: function(cart) {
        $.getJSON('/cart.js', function(cart) {
          refreshCart(cart);
        });
      }
    });
  }

  function getUpsell() {
    var upsellProducts = [];
    var upsellVariants = [];
    var discountProducts = [];
    $.get('https://sheets.googleapis.com/v4/spreadsheets/1bjYv4-F47ExPxn58glJSixlfYkjIMGBFvosHzfoOPSc/values:batchGet?ranges=PDP!A2:ZZ1000&key=AIzaSyCHDtrvbqer-5m6QwwNVs8YbQ_YwAPFyZ8')
    .done(function(data) {
      value = data.valueRanges[0].values;
      product_collections = $('#collection_list').data('collections').split(', ');
      processValues();
    })
    .fail(function() {
      console.error('Failed to fetch data');
    });

    function processValues() {
      var discountArr = [];
      for (let x = 0; x < value.length; x++) {
        var currentProductHandle = $('#product-upsell').data('product');
        var sheetProductHandle = value[x][2];
  
        if (currentProductHandle == sheetProductHandle || $.inArray(value[x][1], product_collections) !== -1) {
          var discountObj = {
            priority: parseInt(value[x][0]),
            product: value[x][2]
          };
  
          for (let i = 0; i < 4; i++) {
            var productIdKey = 'productId_' + (i + 1);
            var variantIdKey = 'variantId_' + (i + 1);
            var discountKey = 'discount_' + (i + 1);
  
            if (value[x][3 + i * 3]) {
              discountObj[productIdKey] = value[x][3 + i * 3];
              discountObj[variantIdKey] = value[x][4 + i * 3] || null;
              discountObj[discountKey] = parseFloat(value[x][5 + i * 3]);
            }
          }
  
          discountArr.push(discountObj);
        }
      }

      var upsellArr = discountArr.length > 0 ?
      discountArr.reduce((previous, current) => previous.priority < current.priority ? previous : current) :
      undefined;

      if (upsellArr) {
        processUpsell(upsellArr);
      }
    }

    function processUpsell(upsellArr) {
      var productKeys = ['productId_1', 'productId_2', 'productId_3', 'productId_4'];
      var variantKeys = ['variantId_1', 'variantId_2', 'variantId_3', 'variantId_4'];
      var discountKeys = ['discount_1', 'discount_2', 'discount_3', 'discount_4'];

      for (let i = 0; i < 4; i++) {
        var productKey = productKeys[i];
        var variantKey = variantKeys[i];
        var discountKey = discountKeys[i];

        if (upsellArr[productKey]) {
          upsellProducts.push(upsellArr[productKey]);
          discountProducts.push(upsellArr[discountKey]);
          upsellVariants.push(upsellArr[variantKey]);
        }
      }
      processProducts();
    }

    function processProducts() {
      var productCount = upsellProducts.length;
      var processedCount = 0;
  
      for (let x = 0; x < productCount; x++) {
        getProductDetails(x, function() {
          processedCount++;
          if (processedCount === productCount) {
            popupContentLayout();
          }
        });
      }
    }

    function getProductDetails(index, callback) {
      var currentProductHandle = $('#product-upsell').data('product');
      var productId = upsellProducts[index];
      var allSoldOut = true;
      $.getJSON('/products/' + productId + '.js')
      .done(function(product) {
        var payload = '';
        var available = false;
  
        var vendor = product.vendor.toUpperCase();
        var title = product.title.toUpperCase().replace(vendor, '').replace('- ', '');
        var comparePrice = product.compare_at_price / 100.0;
        var price = product.price / 100.0;
        var image = product.featured_image;
        var variantId = product.variants[0].id;
        var id = product.id;
        var discount = discountProducts[index];
        var showAllVariants = true;

        if (upsellVariants[index]) {
          var variants = product.variants;
          var variantsPrice = [];
          var variantsComparePrice = [];
          for (let y = 0; y < variants.length; y++) {
            variantsPrice.push(price);
            variantsComparePrice.push(comparePrice);
            if (variants[y].id == upsellVariants[index]) {
              available = variants[y].available;
              title = variants[y].name.toUpperCase().replace(vendor, '');
              comparePrice = variants[y].compare_at_price / 100.0;
              price = variants[y].price / 100.0;
              variantId = variants[y].id;
              showAllVariants = false;
            }
          }
        } else {
          available = product.available;
        }
        if (available) {
          allSoldOut = false;
          var origPrice = price;
          if (price < comparePrice) {
            discount = 0;
          } else {
            if (discount) {
              discount = (price * discount / 100).toFixed(2);
            } else {
              discount = 0;
            }
          }

          price = (price - discount).toFixed(2);
          payload += `<div class="product-item order-${index}" data-index="${index}">`;
          payload += `<div class="product-image">`;
          payload += `<img src="${image}" alt="${title}" width="300" height="300" />`;
          payload += `</div>`;
          payload += `<div class="product-details">`;
          payload += `<small>${vendor}</small>`;
          payload += `<h2>${title}</h2>`;

          if (comparePrice > price) {
            payload += `<h4><span class"><span class="pricing-${id}">$${price}</span></span><span class="our-price"><span style="text-decoration: line-through" class="compare-pricing-${id}">$${comparePrice}</span></span></h4>`;
          } else {
            if (origPrice > price) {
              payload += `<h4><span class"><span class="pricing-${id}">$${price}</span></span><span class="our-price"><span style="text-decoration: line-through" class="compare-pricing-${id}">$${origPrice}</span></span></h4>`;
            } else {
              payload += `<h4><span><span class="pricing-${id}">$${price}</span></span></h4>`;
            }
          }
          
          if (showAllVariants) {
            var variants = product.variants;
            payload += `<div class="product-variants flex mb-8 flex-wrap">`;
            if (variants.length > 1 && variants[0].title != 'Default Title') {
              payload += `<select class="custom-select variant-selector" onchange="upsellVariantSelect(${id}, this, this.options[this.selectedIndex].getAttribute('data-price'), this.options[this.selectedIndex].getAttribute('data-orig'))">`;
              for (let a = 0; a < variants.length; a++) {
                if (variants[a].available) {
  
                  var price = (variants[a].price / 100.0);
                  var comparePrice = (variants[a].compare_at_price / 100.0);
                  var discount = discountProducts[index];
  
                  if (price < comparePrice) {
                    discount = 0;
                  } else {
                    if (discount) {
                      discount = (price * discount / 100).toFixed(2);
                    } else {
                      discount = 0;
                    }
                  }
                  price = (price - discount).toFixed(2);
                  payload += `<option data-price="${price}" data-orig="${variants[a].price / 100.0}" value="${variants[a].id}">${variants[a].title}</option>`;
                }
              }
              payload += `</select>`;
            } else {
              if (variants[0].title != 'Default Title') {
                payload += `<p>${variants[0].title}</p>`;
              } else {
                payload += `<p></p>`;
              }
            }
            payload += `<button class="upsell_addToCart font-inter animated fadeInDown" data-id="${id}" data-product="${currentProductHandle}" data-variant=${variantId} data-price="${price}" data-discount="${discount}" onclick="upsellAddToCart(${id})"><span>Add to Cart</span><svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark"><path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"/></svg></button>`;
            payload += `</div>`;    
          }
          else {
            payload += `<div class="product-variants flex mb-8 flex-wrap">`;
            payload += `<p></p>`;
            payload += `<button class="upsell_addToCart font-inter animated fadeInDown" data-id="${id}" data-product="${currentProductHandle}" data-variant=${variantId} data-price="${price}" data-discount="${discount}" onclick="upsellAddToCart(${id})"><span>Add to Cart</span><svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark"><path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"/></svg></button>`;
            payload += `</div>`;
          }
          payload += `<div class="error-container" data-id="${id}">`;
          payload += `<p class="error"></p>`;
          payload += `</div>`;
          payload += `</div>`;
          payload += `</div>`;
  
          if (!allSoldOut) {
            $('#product-upsell .content-area .product-items').append(payload);
            $('#product-upsell').show();
          }
        }
        
        callback();
      })
      .fail(function() {
        console.error(productId + ' is returning an error.');
        callback();
      });
    }

    function popupContentLayout() { 
      setTimeout(function() { 
        var maxHeight = -1;   
        $('#product-upsell .content-area .product-item .product-details h2').each(function() { 
          maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height(); 
        });

        $('#product-upsell .content-area .product-item .product-details h2').each(function() { 
          $(this).height(maxHeight);
        }); 

        $(window).on('resize', function() {   
          var maxHeight = -1;   
          $('#product-upsell .content-area .product-item .product-details h2').removeAttr('style');   
          $('#product-upsell .content-area .product-item .product-details h2').each(function() {   
            maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();   
          });   
          $('#product-upsell .content-area .product-item .product-details h2').each(function() {   
            $(this).height(maxHeight);   
          });
        }); 
      }, 500); 
    }

    window.upsellVariantSelect = function(productId, variantId) {
      var id = productId;
      var variantId = variantId.value;
      $('.upsell_addToCart[data-id="' + id + '"]').attr('data-variant', variantId);    
    }

    window.upsellAddToCart = function(id) {
      var target = $('.upsell_addToCart[data-id="' + id + '"]');
      var variantId = target.attr('data-variant');   
      var price = target.attr('data-price');   
      var discount = target.attr('data-discount');
      var title = target.attr('data-product');
      var properties = {   
          "Trigger": title,
          "Price": price,   
          "Discount": discount   
      };   
      var data =  {    
          quantity: 1,   
          id: variantId,   
          properties: properties   
      };   

      target.find('.checkmark').addClass('checkmark-active');
      $.ajax({   
        type: 'POST',    
        url: '/cart/add.js',   
        dataType: 'json',    
        data: data,   
        beforeSend() {
          target.attr('disabled', 'disabled').addClass('disabled');
          target.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success: function(data){   
          $.getJSON('/cart.js', function(cart) {   
            target.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            target.removeAttr('disabled').removeClass('disabled');
            target.find('.checkmark').removeClass('checkmark-active');
            target.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);
            refreshCart(cart);
          })   
        },   
        error: function(err) {   
          var errMsg = err.responseJSON.description;   
          $('.error-container[data-id="'+ id +'"] .error').text(errMsg);   
          $('.error-container[data-id="'+ id +'"]').css('display', 'flex');   
          setTimeout(function() {   
            $('.error-container[data-id="'+ id +'"] .error').text('');   
            $('.error-container[data-id="'+ id +'"]').hide();   
            target.text('Add to Cart');   
          },3000);   
        }   
      });   
    }
  }

  
  $('body').on('click', '#heroku-checkout', e => { 
    $('#heroku-checkout').addClass('loading');
    e.preventDefault();
    customCheckOut();
  });

  function customCheckOut() {
    var query = {}; 
    query.line_items = [];

    $.getJSON('/cart.js', function(cart) {
      $.each(cart.items, (index, item) => {
        var variantId = 'gid://shopify/ProductVariant/' + item.variant_id;
        var quantity = item.quantity;

        var hasDiscount = false;
        var discountPrice = 0;
        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (value && title == 'Discount') {
              hasDiscount = true;
              discountPrice = parseFloat(value)
            }
            else if (value && title == 'free_item') {
              hasDiscount = true;
              discountPrice = parseFloat((item.price / 100.0))
            }
          });
        }

        var discount = "discount" + index;
        window[discount] = null;

        if(hasDiscount) {
          window[discount] = [{
            "valueType": "FIXED_PRICE",
            "value" : discountPrice,
            "title": "Discount"
          }]
        }

        var properties = [];
        $.each(item.properties, (title, value) => {
          properties.push({
            name: title,
            value: value
          });
        });

        
        query.line_items.push({
          "variant_id": variantId, 
          "quantity": quantity, 
          "applied_discount": window[discount],
          "properties": properties
        });

      });
            
      $.ajax({
        url: "https://ama-warehouse-98d32edc3a64.herokuapp.com/api/b2c/pricing-app/index.php",  
        method: 'POST',  
        data: JSON.stringify({ query: query}),  
        contentType: "application/json",  
        crossDomain: true,  
        success: function(response){ 
          window.location.href = response
        } 
      });
    });
  }

  function sideCartUpsell() {
    var sideCartUpsellProducts = [];
    var sideCartUpsellVariants = [];
    var discountProducts = [];
    $.get('https://sheets.googleapis.com/v4/spreadsheets/1bjYv4-F47ExPxn58glJSixlfYkjIMGBFvosHzfoOPSc/values:batchGet?ranges=Cart!A2:ZZ1000&key=AIzaSyCHDtrvbqer-5m6QwwNVs8YbQ_YwAPFyZ8', function(data) {
      var value = data.valueRanges[0].values;
      var productTypes = [];
      $('.cart_items.js-cart_items li').each(function() {
          var type = $(this).data('type');
          if (productTypes.indexOf(type) === -1) {
              productTypes.push(type);
          }
      });
      if (value !== undefined && value !== null) {
        var discountArr = []; 
        for(let x = 0; x < value.length; x++) {
          var discountObj = {};

          discountObj.priority = parseInt(value[x][0]);
          discountObj.product = value[x][2];

          if($.inArray(value[x][1], productTypes) !== -1) {   

            var upsell1 = false;
            if(value[x][3]) {
              upsell1 = true;
              discountObj.productId_1 = value[x][2];
              discountObj.variantId_1 = value[x][3];
              discountObj.discount_1 = parseFloat(value[x][4]);
            }
            else {
              if(value[x][2]) {
                upsell1 = true;
                discountObj.variantId_1 = null;
                discountObj.productId_1 = value[x][2];
                discountObj.discount_1 = parseFloat(value[x][4]);
              }
            }

            var upsell2 = false;
            if(value[x][6]) {
              upsell2 = true;
              discountObj.productId_2 = value[x][5];
              discountObj.variantId_2 = value[x][6];
              discountObj.discount_2 = parseFloat(value[x][7]);
            }
            else {
              if(value[x][5]) {
                upsell2 = true;
                discountObj.variantId_2 = null;
                discountObj.productId_2 = value[x][5];
                discountObj.discount_2 = parseFloat(value[x][7]);
              }
            }

            var upsell3 = false;
            if(value[x][9]) {
              upsell3 = true;
              discountObj.productId_3 = value[x][8];
              discountObj.variantId_3 = value[x][9];
              discountObj.discount_3 = parseFloat(value[x][10]);
            }
            else {
              if(value[x][8]) {
                upsell3 = true;
                discountObj.variantId_3 = null;
                discountObj.productId_3 = value[x][8];
                discountObj.discount_3 = parseFloat(value[x][10]);
              }
            }

            var upsell4 = false;
            if(value[x][12]) {
              upsell4 = true;
              discountObj.productId_4 = value[x][11];
              discountObj.variantId_4 = value[x][12];
              discountObj.discount_4 = parseFloat(value[x][13]);
            }
            else {
              if(value[x][11]) {
                upsell4 = true;
                discountObj.variantId_4 = null;
                discountObj.productId_4 = value[x][11];
                discountObj.discount_4 = parseFloat(value[x][13]);
              }
            }

            if(upsell1 || upsell2 || upsell3 || upsell4) {
              discountArr.push(discountObj);
            }

          }
        }

        var upsellArr;
        if (discountArr.length > 0) {
          upsellArr = discountArr.reduce(function(previous, current) {
            return previous.priority < current.priority ? previous : current;
          });
        } else {
          upsellArr = undefined;
        }

        if(upsellArr) {
          var product_1 = upsellArr['productId_1'];
          var product_2 = upsellArr['productId_2'];
          var product_3 = upsellArr['productId_3'];
          var product_4 = upsellArr['productId_4'];

          var variant_1 = upsellArr['variantId_1'];
          var variant_2 = upsellArr['variantId_2'];
          var variant_3 = upsellArr['variantId_3'];
          var variant_4 = upsellArr['variantId_4'];

          var discount_1 = upsellArr['discount_1'];
          var discount_2 = upsellArr['discount_2'];
          var discount_3 = upsellArr['discount_3'];
          var discount_4 = upsellArr['discount_4'];

          if(product_1) {
            sideCartUpsellProducts.push(product_1);
            discountProducts.push(discount_1);
            sideCartUpsellVariants.push(variant_1);
          }

          if(product_2) {
            sideCartUpsellProducts.push(product_2);
            discountProducts.push(discount_2);
            sideCartUpsellVariants.push(variant_2);
          }

          if(product_3) {
            sideCartUpsellProducts.push(product_3);
            discountProducts.push(discount_3);
            sideCartUpsellVariants.push(variant_3);
          }

          if(product_4) {
            sideCartUpsellProducts.push(product_4);
            discountProducts.push(discount_4);
            sideCartUpsellVariants.push(variant_4);
          }

          var count = 0;
          for(let x = 0; x < sideCartUpsellProducts.length; x++) {
            var allSoldOut = true;
            $.getJSON('/products/'+ sideCartUpsellProducts[x] +'.js', function(product) {
              var payload = '';
              var available = false;

              var vendor = product.vendor.toUpperCase();
              var title = product.title.toUpperCase().replace(vendor, '').replace('- ', '');
              var url = product.url;
              var comparePrice = product.compare_at_price / 100.0;
              var price = product.price / 100.0;
              var image = product.featured_image;
              var variantId = product.variants[0].id;
              var id = product.id;
              var discount = discountProducts[x];
              var showAllVariants = true;

              if(sideCartUpsellVariants[x]) {
                var variants = product.variants;
                var variantsPrice = [];
                var variantsComparePrice = [];
                for(let y = 0; y < variants.length; y++) {
                  variantsPrice.push(price);
                  variantsComparePrice.push(comparePrice);
                  if(variants[y].id == sideCartUpsellVariants[x]) {
                    available = variants[y].available;
                    title = variants[y].name.toUpperCase().replace(vendor, '');
                    comparePrice = variants[y].compare_at_price / 100.0;
                    price = variants[y].price / 100.0;
                    variantId = variants[y].id;
                    showAllVariants = false;
                  }
                }
              }
              else {
                available = product.available;
              }

              if(available) {
                allSoldOut = false;
                var origPrice = price;

                if(price < comparePrice) {
                    discount = 0;
                }
                else {
                    if(discount) {
                        discount = (price * discount / 100).toFixed(2);
                    }
                    else {
                        discount = 0;
                    }
                }

                price = (price - discount).toFixed(2);

                payload += `<div class="upsell-cart__item">`;
                  payload += `<a href="${url}">`;
                    payload += `<div class="upsell_image">`;
                      payload += `<img class="lazyload" data-src="${image}" alt="${title}" width="70" height="70" />`;
                    payload += `</div>`;
                  payload += `</a>`;
                  payload += `<div class="mini-cart__item-content">`;
                    payload += `<div class="upsell-title">`;
                      payload += `<a href="${url}">`;
                        payload += `<p class="product-vendor uppercase font-bold">${vendor}</p>`;
                        payload += `<p class="product-title">${title}</p>`;
                      payload += `</a>`;
                    payload += `</div>`;

                    if(comparePrice > price) {
                    payload += `<div class="mini-cart__item-price">`;
                      payload += `<span class="money sale">$${price}</span>`;
                      payload += `<span class="money was_price">$${compare_price}</span>`;
                    payload += `</div>`;
                    }
                    else {
                    payload += `<div class="upsell-price">`;
                      payload += `<span class="money">$${price}</span>`;
                    payload += `</div>`;
                    }
                  payload += `</div>`;
                payload += `</div>`;
              }

              if(allSoldOut == false) {   
                $('.sidecart-upsell').append(payload).show();
              }

            }).fail(function() {  
              console.log( sideCartUpsellProducts[x] + ' is returning an error.' );  
            })
            .always(function() {
              if(count === sideCartUpsellProducts.length - 1) { 
              }   
              else {   
                count++;
              }
            });
          }
        }
      }
    })
  }

  sideCartUpsell();

  function showPopup() {
    $('#printing-popup').addClass('active');
    $('#printing-popup [data-step="1"]').show();
    $('#printing-popup [data-step="2"]').hide();
    $('#printing-popup [data-step="3"]').hide();
    $('body').addClass('blocked-scroll');
  }

  function showPopupStep2() {
    var split_selected = $('.dd-option option:selected').text().split(' / ');
    for(x = 0; x < split_selected.length; x++) {
      var count = x + 1;
      $('#popup-option-' + count).val(split_selected[x]).change();
    }

    $('#printing-popup [data-step="1"]').hide();
    $('#printing-popup [data-step="2"]').show();
  }

  function showPopupStep3() {
    $('#printing-popup [data-step="1"]').hide();
    $('#printing-popup [data-step="2"]').hide();
    $('#printing-popup [data-step="3"]').show();
  }

  function noPopupCombo(productId) {
    const MIXMATCH_CHILD_SELECT = `#combowise-mixmatch_${productId} .combowise-mixmatch_select`;
    const selectedVariants = document.querySelectorAll(MIXMATCH_CHILD_SELECT);
    const nodes = Array.prototype.slice.call(selectedVariants, 0); 
    let variantIds = nodes.map(e => e.options[e.selectedIndex].value); 
    let title = nodes.map(e => e.options[e.selectedIndex].text);

    let meta = {}; 
    variantIds.map(id => { 
      if (meta[id]) { 
        meta[id] += 1; 
      } else { 
        meta[id] = 1; 
      } 
    }); 

    let items = [];
    for (let key in meta) { 
      items.push(
        { 
          id: +key, 
          quantity: meta[key], 
          title: title,
          properties: {
            'Combo Id': productId
          }
        }
      ); 
    }

    let combowiseForm = { 
      items
    };
    
    $.ajax({
      type: 'POST',
      data: combowiseForm,
      url: '/cart/add.js',
      dataType: 'json',
      success: function(response) {
        $.getJSON('/cart.js', function(cart) {
          refreshCart(cart);
          $('#shopify-section-sidecart .cart-container').addClass('active_link');
         $('#printing-popup').removeClass('active');
        });
      },
      error: function(err) {
        var err_msg = err.responseJSON.description;
        var err_payload = `<div class="err_payload text-center leading-4">${err_msg}</div>`;
        $('.err_holder').append(err_payload);
        setTimeout(function() {
          $('.err_payload').remove();
        },2000);
      }
    });
  }

  function noPopupJersey() {
    var variantId = $('.dd-option option:selected').val();
    var quantity = $('#quantity').val();
    var data = {
      items: [
        {
          id: variantId, 
          quantity: quantity,
        }
      ]
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(product) {
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success(cart) {
            setTimeout(function () {
              refreshCart(cart);
             $('#printing-popup').removeClass('active');
              $('#shopify-section-sidecart .cart-container').addClass('active_link');
            });
          }
        });
      },
      error: function(err) {
        var err_msg = err.responseJSON.description;
        var err_payload = `<div class="err_payload text-center leading-4">${err_msg}</div>`;
        $('.err_holder').append(err_payload);
        setTimeout(function() {
          $('.err_payload').remove();
        },2000);
      }
    });
  }

  function noJerseyPrinting(arr, id) {
    let items = [];
    for(let i = 0; i < arr.length; i++) {
      items.push(
        { 
          id: arr[i], 
          quantity: 1,
          properties: {
            'Combo Id': id
          }
        }
      ); 
    }
    
    let combowiseForm = { 
      items
    };
    $.ajax({
      type: 'POST',
      data: combowiseForm,
      url: '/cart/add.js',
      dataType: 'json',
      success: function(response) {
        $.getJSON('/cart.js', function(cart) {
          refreshCart(cart);
          $('#shopify-section-sidecart .cart-container').addClass('active_link');
         $('#printing-popup').removeClass('active');
        });
      },
      error: function(err) {
        var err_msg = err.responseJSON.description;
        var err_payload = `<div class="err_payload text-center leading-4">${err_msg}</div>`;
        $('.err_holder').append(err_payload);
        setTimeout(function() {
          $('.err_payload').remove();
        },2000);
      }
    });
  }

  function setVariantPopup(productId) {

    var variantData = $('#variant-container-' + productId).data('variants').split('###');
    var variantDataEach = [];
      variantData.forEach(function(variantData) {
        variantData = variantData.split('^');
        variantDataEach.push(variantData);
      })
  
    var variants = [];
    for(var i = 0; i < variantDataEach.length - 1; i++){
      var options = variantDataEach[i][1].split('*');
      var payload = {
        id: variantDataEach[i][0],
        options: options.filter(function (el) {return el != '';}),
        available: variantDataEach[i][2],
        price: window.Shopify.formatMoney(parseFloat(variantDataEach[i][3]), $('body').data('money-format')),
        price: window.Shopify.formatMoney(parseFloat(variantDataEach[i][3]), $('body').data('money-format')),
        sku:variantDataEach[i][5],
        afterpay: window.Shopify.formatMoney((parseFloat(variantDataEach[i][3])) / 4, $('body').data('money-format')),
        policy: variantDataEach[i][7],
        bigat: variantDataEach[i][8],
        quantity: variantDataEach[i][9],
      }
      variants.push(payload);
    }
    if(variants.length == 1){
      var variantCounter = '0';
    } 
    else {
      var selectValues = [];
      $('select[data-popup-product='+ productId +']').each(function(){
          selectValues.push($(this).val());
      });
    var variantCounter = null;
      for(var i = 0; i < variants.length; i++){
        if(arraysEqual(selectValues, variants[i].options)){
          variantCounter = i;
          break;
        }
      }
    }

    var targetInput = '#variant-' + productId;
    var targetPrice = '#printing-popup div#step2-content span#popupPrice';
    var targetBtn = '#printing-popup div#step2-content a#next-step';
    
    if(variantCounter != null) {
      $(targetInput).val(variants[variantCounter].id);
      $(targetInput).attr('data-options', variants[variantCounter].options);
      $(targetPrice).html(variants[variantCounter].price);
      if(variants[variantCounter].available == "true") {
          $(targetBtn).removeClass('disabled').html('Add to cart');
      }
      else {
        $(targetBtn).addClass('disabled').html('Out of Stock');
      }
    }
  }

  function arraysEqual(arr1, arr2) {
    if(arr1.length !== arr2.length)
      return false;
    for(var i = arr1.length; i--;) {
      if(arr1[i] !== arr2[i])
      return false;
    }
    return true;
  }

  function updateFontSize(letterCount) {
    if($(window).width() > 768) {
      if(letterCount < 5) {
        $('#print-name').css('fontSize', '100px');
      }
      else if(letterCount >= 11) {
        $('#print-name').css('fontSize', '60px');
      }
      else if(letterCount >= 9) {
        $('#print-name').css('fontSize', '80px');
      }
      else if(letterCount >= 7) {
        $('#print-name').css('fontSize', '80px');
      }
      else if(letterCount >= 5) {
        $('#print-name').css('fontSize', '100px');
      }
    }
    else if($(window).width() >= 576) {
      if(letterCount < 5) {
        $('#print-name').css('fontSize', '100px');
      }
      else if(letterCount >= 11) {
        $('#print-name').css('fontSize', '50px');
      }
      else if(letterCount >= 9) {
        $('#print-name').css('fontSize', '60px');
      }
      else if(letterCount >= 7) {
        $('#print-name').css('fontSize', '65px');
      }
      else if(letterCount >= 5) {
        $('#print-name').css('fontSize', '100px');
      }
    }
    else if($(window).width() >= 425) {
      if(letterCount < 5) {
        $('#print-name').css('fontSize', '70px');
      }
      else if(letterCount >= 11) {
        $('#print-name').css('fontSize', '38px');
      }
      else if(letterCount >= 9) {
        $('#print-name').css('fontSize', '50px');
      }
      else if(letterCount >= 7) {
        $('#print-name').css('fontSize', '55px');
      }
      else if(letterCount >= 5) {
        $('#print-name').css('fontSize', '70px');
      }
    }
    else if($(window).width() >= 320) {
      if(letterCount < 5) {
        $('#print-name').css('fontSize', '55px');
      }
      else if(letterCount >= 11) {
        $('#print-name').css('fontSize', '30px');
      }
      else if(letterCount >= 9) {
        $('#print-name').css('fontSize', '35px');
      }
      else if(letterCount >= 7) {
        $('#print-name').css('fontSize', '40px');
      }
      else if(letterCount >= 5) {
        $('#print-name').css('fontSize', '55px');
      }
    }
  }

  function updateNumberFontSize(numberCount) {
    if($(window).width() > 768) {
      if(numberCount < 3) {
        $('#print-number').css('fontSize', '300px');
      }
      else {
        $('#print-number').css('fontSize', '190px');
      }
    }
    else if($(window).width() >= 576) {
      if(numberCount < 3) {
        $('#print-number').css('fontSize', '300px');
      }
      else {
        $('#print-number').css('fontSize', '190px');
      }
    }
    else if($(window).width() >= 425) {
      if(numberCount < 3) {
        $('#print-number').css('fontSize', '300px');
      }
      else {
        $('#print-number').css('fontSize', '190px');
      }
    }
    else if($(window).width() >= 320) {
      if(numberCount < 3) {
        $('#print-number').css('fontSize', '260px');
      }
      else {
        $('#print-number').css('fontSize', '190px');
      }
    }
  }


  $(window).on('resize', function() {
    if($('#editor-name').length) {
      var letterCount = $('#editor-name').val().length;
      var numberCount = $('#editor-number').val().length;
      updateFontSize(letterCount);
      updateNumberFontSize(numberCount);
    }
  });

  $('#editor-name').on('input', function() {
    var c = this.selectionStart,
      r = /[^a-z0-9 ]/gi,
      v = $(this).val();
    if(r.test(v)) {
      $(this).val(v.replace(r, ''));
      c--;
    }
    this.setSelectionRange(c, c);
    if($(this).val() == '') {
      $('#print-name').text('Name');
      $('#prop-jersey-name').val('');
      $('#editor-name').val('');
    }
    else {
      $('#print-name').text($(this).val());
      $('#prop-jersey-name').val($(this).val());
    }
    var letterCount = $(this).val().length;
    updateFontSize(letterCount);
  });

  $('#editor-number').on('input', function() {
    if($(this).val() == '') {
      $('#print-number span').html('00 <s><img crossorigin="anonymous" src="//amawarehouse.com.au/cdn/shop/t/156/assets/print-logo.svg?v=21378549629599503011748307317" alt="AMA Logo"></s>');
      $('#prop-jersey-number').val('');
      $('#editor-number').val('');
    }
    else {
      $('#print-number span').html($(this).val() + '<s><img crossorigin="anonymous" src="//amawarehouse.com.au/cdn/shop/t/156/assets/print-logo.svg?v=21378549629599503011748307317" alt="AMA Logo"></s>');
      $('#prop-jersey-number').val($(this).val());
    }
    var numberCount = $(this).val().length;
    updateNumberFontSize(numberCount);
  });

  $('.printing-choices input[type="radio"]').on('change', function() {
    var selected = $(this).val();
    $('.print-data').attr('class', 'print-data ' + selected);
  });

  $('.printing-popup').on('click', function(e) {
    e.preventDefault();
    $('body').addClass('blocked-scroll');
    $('#printing-popup').addClass('active');
    $('#printing-popup [data-step="1"]').hide();
    $('#printing-popup [data-step="2"]').show();
    $('#printing-popup [data-step="3"]').hide();
  });

  $('#add-to-order').on('click', function(e) {
    $('#add-to-order').addClass('loading');
    e.preventDefault();
    $('#printing-popup').addClass('active');
    $('body').addClass('blocked-scroll');
    var name = $('#prop-jersey-name').val();
    var number = $('#prop-jersey-number').val();
    var id = $('input[name="layout"]:checked').data('id');

    if(name && number) {
      $('#printing-popup').addClass('active');
      $('body').addClass('blocked-scroll');
      var scale = 10;
      if ($(window).width() < 576) {
        scale = 15;
      }
      else if ($(window).width() < 425) {
        scale = 11;
      }

      var productId = $('.dd-option').data('id');
      var variantId = $('.dd-option option:selected').val();
      var quantity = $('#quantity').val();
      var jerseyName = $('#prop-jersey-name').val();
      var jerseyNumber = $('#prop-jersey-number').val();


      if ($(this).data('combo')) {
        let items = [];
        if ($(this).data('custom') == true) {
          var option1 = $('.combo-dropdown #combo-form-0').val();
          var option2 = $('.combo-dropdown #combo-form-1').val();

          if (option1 !== null && option1 !== 'null') {
            items.push({
              id: option1,
              quantity: 1,
              properties: {
                'Jersey Name': jerseyName,
                'Jersey Number': jerseyNumber,
                'Combo Id': productId
              }
            });
          }

          if (option2 !== null && option2 !== 'null') {
            items.push({
              id: option2,
              quantity: 1,
              properties: {
                'Jersey Name': jerseyName,
                'Jersey Number': jerseyNumber,
                'Combo Id': productId
              }
            });
          }
        }
        else {
          const POPUP_MIXMATCH_CHILD_SELECT = `#combowise-popup-mixmatch_${productId} .combowise-mixmatch_select`;
          const selectedVariants = document.querySelectorAll(POPUP_MIXMATCH_CHILD_SELECT);
          const nodes = Array.prototype.slice.call(selectedVariants, 0); 
          let variantIds = nodes.map(e => e.options[e.selectedIndex].value); 
          let title = nodes.map(e => e.options[e.selectedIndex].text);
          var productId = $('.dd-option').data('id');

          let meta = {}; 
          variantIds.map(id => { 
            if (meta[id]) { 
              meta[id] += 1; 
            } else { 
              meta[id] = 1; 
            } 
          }); 

          for (let key in meta) { 
            items.push(
              { 
                id: +key, 
                quantity: meta[key], 
                title: title,
                properties: {
                  'Jersey Name': jerseyName,
                  'Jersey Number': jerseyNumber,
                  'Combo Id': productId
                }
              }
            ); 
          }
        }

        let combowiseForm = { 
          items
        };

        var productName = $(this).data('product');
        
        var print = {
          id: parseInt(id),
          quantity: 1,
          properties: {
            'Print For': productName,
            'Jersey Name': jerseyName,
            'Jersey Number': jerseyNumber
          }
        };
                
        combowiseForm.items.push(print);

        $.ajax({
          type: 'POST',
          data: combowiseForm,
          url: '/cart/add.js',
          dataType: 'json',
          success: function(response) {
            $.getJSON('/cart.js', function(cart) {
              refreshCart(cart);
              $('#shopify-section-sidecart .cart-container').addClass('active_link');
             $('#printing-popup').removeClass('active');
              $('#add-to-order').removeClass('loading');
              $('body').removeClass('blocked-scroll');
            });
          },
          error: function(err) {
            var err_msg = err.responseJSON.description;
            var err_payload = `<div class="err_payload text-center leading-4">${err_msg}</div>`;
            $('.err_holder').append(err_payload);
            setTimeout(function() {
              $('.err_payload').remove();
            },2000);
            $('#add-to-order').removeClass('loading');
          }
        });
      }
      else {
        var productName = $(this).data('product');
        var option = $('.dd-option option:selected').text()
        
        var obj = {};
        obj.items = [];
        var jersey = {
          quantity: parseInt(quantity),
          id: parseInt(variantId),
          properties: {
            'Jersey Name': jerseyName,
            'Jersey Number': jerseyNumber
          }
        };
  
        obj.items.push(jersey);
  
        var print = {
          quantity: parseInt(quantity),
          id: parseInt(id),
          properties: {
            'Print For': productName + ' - ' + option,
            'Jersey Name': jerseyName,
            'Jersey Number': jerseyNumber
          }
        };
  
        obj.items.push(print);
  
        $.ajax({
          type: 'POST',
          data: obj,
          url: '/cart/add.js',
          dataType: 'json',
          success: function(response) {
            $.getJSON('/cart.js', function(cart) {
              refreshCart(cart);
              $('#shopify-section-sidecart .cart-container').addClass('active_link');
             $('#printing-popup').removeClass('active');
              $('body').removeClass('blocked-scroll');
              $('#add-to-order').removeClass('loading');
            });
          },
          error: function(err) {
            var err_msg = err.responseJSON.description;
            var err_payload = `<div class="err_payload text-center leading-4 mt-4">${err_msg}</div>`;
            $('#printing-editor').append(err_payload);
            $('#add-to-order').removeClass('loading');
            setTimeout(function() {
              $('.err_payload').remove();
            },2000);
          }
        });
      }
      
    }
    else {
      if(name == '' && number) {
        alert('Please add Name');
      }
      else if(number == '' && name) {
        alert('Please add Number');
      }
      else {
        alert('Please add Name and Number');
      }
      $('#add-to-order').removeClass('loading');
    }
  });

  $('#printing-popup button.close').on('click', function(e) {
    e.preventDefault();
   $('#printing-popup').removeClass('active');
    $('body').removeClass('blocked-scroll');
  });
  
  // Jersey Printing No Thanks
  $('#end-step').on('click', function(e) {
    e.preventDefault();
    if ($(this).data('combo') == true) {
      var productId = $(this).data('id');
      noPopupCombo(productId);
    }
    else if ($(this).data('custom') == true) {
      var option1 = $('.combo-dropdown #combo-form-0').val();
      var option2 = $('.combo-dropdown #combo-form-1').val();
      var id = $(this).data('id');
      var data = {
        items: []
      };
  
      if (option1 !== null && option1 !== 'null') {
        data.items.push({
          id: option1,
          quantity: 1,
          properties: {
            'Combo Id': id,
          }
        });
      }
  
      if (option2 !== null && option2 !== 'null') {
        data.items.push({
          id: option2,
          quantity: 1,
          properties: {
            'Combo Id': id,
          }
        });
      }
      
      $.ajax({
        type: 'POST',
        data: data,
        url: '/cart/add.js',
        dataType: 'json',
        success: function(response) {
          $.getJSON('/cart.js', function(cart) {
            refreshCart(cart);
            $('#shopify-section-sidecart .cart-container').addClass('active_link');
           $('#printing-popup').removeClass('active');
          });
        },
        error: function(err) {
          var err_msg = err.responseJSON.description;
          var err_payload = `<div class="err_payload text-center leading-4">${err_msg}</div>`;
          $('.err_holder').append(err_payload);
          setTimeout(function() {
            $('.err_payload').remove();
          },2000);
        }
      });
    }
    else {
      noPopupJersey();
    }
    $('body').removeClass('blocked-scroll');
  });

  // Jersey Printing - 2nd Step
  $('#step1-content #next-step').on('click', function(e) {
    e.preventDefault();
    showPopupStep2();
  });

  // Auto-select Variant in Popup
  $('select[data-popup-product]').on('change', function() {
    var productId = $(this).data('popup-product');
    setVariantPopup(productId);
    var value = $(this).val();
    $(`.swatch-element[data-value="${value}"]`).click();
  });

  // Jersey Printing - 3rd Step
  $('#step2-content #next-step').on('click', function(e) {
    e.preventDefault();
    showPopupStep3();
  });

  $(document).on('click', '#variant-sku #combo-submit', function() {
    var show_jersey_printing = false;
    if ($('#printing-popup').length > 0 && show_jersey_printing) {
      $('#printing-popup').addClass('active');
      $('#printing-popup [data-step="1"]').show();
      $('#printing-popup [data-step="2"]').hide();
      $('#printing-popup [data-step="3"]').hide();
      $('body').addClass('blocked-scroll');
    }
    else {
      let selectedValues = [];
      var comboId = $(this).data('id');
      $('.combo-dropdown').each(function() {
        let select = $(this).find('select');
        let selectedValue = select.val();
        selectedValues.push(selectedValue);
      });
  
      noJerseyPrinting(selectedValues, comboId);
    }
  });
  

  function tagBasedGift() {
    $.getJSON('/cart.js', async cart => {
      var tagBasedGift = document.getElementById('sidecart_promo').dataset.tagbasedgift;
      const tagBasedGiftArray = JSON.parse(tagBasedGift);
      const target = tagBasedGiftArray.target_tag;
      const name = tagBasedGiftArray.promo_name;
      const free_gift_id = tagBasedGiftArray.free_gift_id;
      var targetTagExist = false;

      for (const item of cart.items) {
        const product = await getProduct(item.handle);
        if (product.tags.indexOf(target) > -1) {
          targetTagExist = true;
          break;
        }
      }
      const freeItemAlreadyInCart = cart.items.some(item => item.properties?.promo === name);
      if(targetTagExist) {
        $('.free-gift-banner[data-type="tag_based"]').show();
        if (!freeItemAlreadyInCart) {
          addFreeGift(free_gift_id, name);
        }
      }
      else {
        $('.free-gift-banner[data-type="tag_based"]').hide();
        if (freeItemAlreadyInCart) {
          removeFreeGift(free_gift_id);
        }
      }
    });

    async function getProduct(handle) {
      return new Promise((resolve, reject) => {
        $.getJSON(window.Shopify.routes.root + `products/${handle}.js`, product => {
          resolve(product);
        }).fail(error => {
          reject(error);
        });
      });
    }
  }

  // Check for Free Gift
  if (document.getElementById('sidecart_promo').dataset.tagbasedgift) {
    tagBasedGift();
  }

});


/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t, e) { const o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? `0${o}` : o; } if (typeof window.Shopify === 'undefined') window.Shopify = {}; window.Shopify.each = function (t, e) { for (let o = 0; o < t.length; o++)e(t[o], o); }, window.Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o; }, window.Shopify.arrayIncludes = function (t, e) { for (let o = 0; o < t.length; o++) if (t[o] == e) return !0; return !1; }, window.Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e; }, window.Shopify.isDefined = function (t) { return typeof t === 'undefined' ? !1 : !0; }, window.Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1); }, window.Shopify.extend = function (t, e) { function o() {}o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype; }, window.Shopify.locationSearch = function () { return window.location.search; }, window.Shopify.locationHash = function () { return window.location.hash; }, window.Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t); }, window.Shopify.urlParam = function (t) { const e = RegExp(`[?&]${t}=([^&#]*)`).exec(window.Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, ' ')); }, window.Shopify.newState = function (t, e) { let o; return o = window.Shopify.urlParam(t) ? window.Shopify.locationSearch().replace(RegExp(`(${t}=)[^&#]+`), `$1${e}`) : window.Shopify.locationSearch() === '' ? `?${t}=${e}` : `${window.Shopify.locationSearch()}&${t}=${e}`, o + window.Shopify.locationHash(); }, window.Shopify.setParam = function (t, e) { window.Shopify.replaceState(window.Shopify.newState(t, e)); }, window.Shopify.Product = function (t) { window.Shopify.isDefined(t) && this.update(t); }, window.Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property]; }, window.Shopify.Product.prototype.optionNames = function () { return window.Shopify.getClass(this.options) == 'Array' ? this.options : []; }, window.Shopify.Product.prototype.optionValues = function (t) { if (!window.Shopify.isDefined(this.variants)) return null; const e = window.Shopify.map(this.variants, e => { const o = `option${t + 1}`; return void 0 == e[o] ? null : e[o]; }); return e[0] == null ? null : window.Shopify.uniq(e); }, window.Shopify.Product.prototype.getVariant = function (t) { let e = null; return t.length != this.options.length ? e : (window.Shopify.each(this.variants, o => { for (var i = !0, r = 0; r < t.length; r++) { const n = `option${r + 1}`; o[n] != t[r] && (i = !1); } return i == 1 ? void (e = o) : void 0; }), e); }, window.Shopify.Product.prototype.getVariantById = function (t) { for (let e = 0; e < this.variants.length; e++) { const o = this.variants[e]; if (t == o.id) return o; } return null; }, window.Shopify.money_format = '$', window.Shopify.formatMoney = function (t, e) { function o(t, e) { return typeof t === 'undefined' ? e : t; } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ','), r = o(r, '.'), isNaN(t) || t == null) return 0; t = (t / 100).toFixed(e); const n = t.split('.'); const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`); const s = n[1] ? r + n[1] : ''; return a + s; } typeof t === 'string' && (t = t.replace('.', '')); let r = ''; const n = /\{\{\s*(\w+)\s*\}\}/; const a = e || this.money_format; switch (a.match(n)[1]) { case 'amount': r = i(t, 2); break; case 'amount_no_decimals': r = i(t, 0); break; case 'amount_with_comma_separator': r = i(t, 2, '.', ','); break; case 'amount_with_apostrophe_separator': r = i(t, 2, "'", '.'); break; case 'amount_no_decimals_with_comma_separator': r = i(t, 0, '.', ','); } return a.replace(n, r); }, window.Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = 'selector-wrapper', this.selectorClass = 'single-option-selector', this.variantIdFieldIdSuffix = '-variant-id', this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new window.Shopify.Product(e.product), this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new window.Shopify.OptionSelectors.HistoryState(this)), !0; }, window.Shopify.OptionSelectors.prototype.initDropdown = function () { const t = { initialLoad: !0 }; const e = this.selectVariantFromDropdown(t); if (!e) { const o = this; setTimeout(() => { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t); }); } }, window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { const e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t); }, window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) { const e = document.getElementById(t); const o = e.parentNode; window.Shopify.each(this.buildSelectors(), t => { o.insertBefore(t, e); }), e.style.display = 'none', this.variantIdField = e; }, window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { let e = document.getElementById(this.domIdPrefix).querySelector('[selected]'); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; const o = e.value; return this.selectVariant(o, t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { const e = window.Shopify.urlParam('variant'); return this.selectVariant(e, t); }, window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { const o = this.product.getVariantById(t); if (o == null) return !1; for (let i = 0; i < this.selectors.length; i++) { const r = this.selectors[i].element; const n = r.getAttribute('data-option'); const a = o[n]; a != null && this.optionExistInSelect(r, a) && (r.value = a); } return typeof jQuery !== 'undefined' ? jQuery(this.selectors[0].element).trigger('change', e) : this.selectors[0].element.onchange(e), !0; }, window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (let o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0; }, window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { window.Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = `product-${this.product.id}-variant-selector`; const o = document.getElementById(t); window.Shopify.each(this.buildSelectors(), t => { o.appendChild(t); }); }, window.Shopify.OptionSelectors.prototype.buildSelectors = function () { for (let t = 0; t < this.product.optionNames().length; t++) { const e = new window.Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e); } const o = this.selectorDivClass; const i = this.product.optionNames(); const r = window.Shopify.map(this.selectors, t => { const e = document.createElement('div'); if (e.setAttribute('class', o), i.length > 1) { const r = document.createElement('label'); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r); } return e.appendChild(t.element), e; }); return r; }, window.Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { const o = this.selectors[e].element.value; t.push(o); } return t; }, window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { const o = this.selectedValues(); const i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), this.historyState != null && this.historyState.onVariantChange(i, this, e); }, window.Shopify.OptionSelectorsFromDOM = function (t, e) { const o = e.optionNames || []; const i = e.priceFieldExists || !0; const r = e.delimiter || '/'; const n = this.createProductFromSelector(t, o, i, r); e.product = n, window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e); }, window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM, window.Shopify.OptionSelectors), window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!window.Shopify.isDefined(o)) var o = !0; if (!window.Shopify.isDefined(i)) var i = '/'; const r = document.getElementById(t); const n = r.childNodes; let a = (r.parentNode, e.length); const s = []; window.Shopify.each(n, (t, r) => {
    if (t.nodeType == 1 && t.tagName.toLowerCase() == 'option') {
      const n = t.innerHTML.split(new RegExp(`\\s*\\${i}\\s*`)); e.length == 0 && (a = n.length - (o ? 1 : 0)); const p = n.slice(0, a); const l = o ? n[a] : ''; const c = (t.getAttribute('value'), {
        available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2],
      }); s.push(c);
    }
  }); const p = { variants: s }; if (e.length == 0) { p.options = []; for (let l = 0; a > l; l++)p.options[l] = `option ${l + 1}`; } else p.options = e; return p;
}, window.Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement('select'); for (let r = 0; r < i.length; r++) { const n = document.createElement('option'); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n); } return this.element.setAttribute('class', this.multiSelector.selectorClass), this.element.setAttribute('data-option', `option${e + 1}`), this.element.id = `${t.domIdPrefix}-option-${e}`, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i); }, !0; }, window.Shopify.Image = {
  preload(t, e) { for (let o = 0; o < t.length; o++) { const i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)); } }, loadImage(t) { (new Image()).src = t; }, switchImage(t, e, o) { if (t && e) { const i = this.imageSize(e.src); const r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r; } }, imageSize(t) { const e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return e != null ? e[1] : null; }, getSizedImageUrl(t, e) { if (e == null) return t; if (e == 'master') return this.removeProtocol(t); const o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (o != null) { const i = t.split(o[0]); const r = o[0]; return this.removeProtocol(`${i[0]}_${e}${r}`); } return null; }, removeProtocol(t) { return t.replace(/http(s)?:/, ''); },
}, window.Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t); }, window.Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener('popstate', e => { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }); }); }, window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || window.Shopify.setParam('variant', t.id)); }, window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState; };

$(document)
  .on('shopify:block:select', e => {
    const { blockId } = e.detail;
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials') || $parentSection.hasClass('shopify-section--shoppable-image--slider-enabled')) {
      sliderBlock.select(blockId, $parentSection);
    }
  });

$(document)
  .on('shopify:block:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
  });

$(document)
  .on('shopify:section:reorder', e => {
    window.utils.initializeSectionWrapper();
  });

$(document)
  .on('shopify:section:load', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.accordion.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
    }

    if ($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template') || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      window.collectionSidebarFilter.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.sidebarAccordions.init();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.searchAutocomplete.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.meganavManager.injectAll();
      window.header.init();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.add($parentSection[0]);
    }
  });

$(document)
  .on('shopify:section:unload', e => {
    const $target = $(e.target);
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.unload($parentSection.find('[data-logo-wrapper]'));
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
      window.utils.initializeSectionWrapper();
    });
  });

$(document)
  .on('shopify:section:select', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  });

$(document)
  .on('shopify:section:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.deselect();
    }
  });   
      
    // $('#shopify-section-sidecart .cart-container').addClass('active_link');

  $(document).ready(function() {
    function checkScreenSize() {
      var desktopCarousel = document.getElementById('desktop-usp-bar');
      var mobileCarousel = document.getElementById('mobile-usp-bar');
      if (window.innerWidth >= 1366) {
          desktopCarousel.style.display = 'block';
          mobileCarousel.style.display = 'none';
          desktopFlkty.resize();
      }
      else {
          desktopCarousel.style.display = 'none';
          mobileCarousel.style.display = 'block';
          mobileFlkty.resize();
      }
    }

    var desktopFlkty = new Flickity('#desktop-usp-bar', {
      cellAlign: 'left',
      contain: true,
      setGallerySize: false,
      autoPlay: true,
      pageDots: false,
      prevNextButtons: false,
      rightToLeft: true,
      wrapAround: true
    });
    var mobileFlkty = new Flickity('#mobile-usp-bar', {
      cellAlign: 'left',
      contain: true,
      setGallerySize: false,
      autoPlay: true,
      pageDots: false,
      prevNextButtons: false,
      rightToLeft: true,
      wrapAround: true
    });

    checkScreenSize();

    window.onresize = function() {
        checkScreenSize();
    };

    $(".search-txt").focus(function() {
        $('.search-container').addClass("active");
    });
    
    // $(".search-txt").blur(function() {
    //   $('.search-container').removeClass("active");
    // });

    $(".search-txt").blur(function() {
      if (!$('.instant-search-menu').length) {
        $('.search-container').removeClass("active");
      }
    });
    


    // View Size Guide
    $('#view-sizeguide').on('click', function(e) {
      e.preventDefault();
      $('.sizeguide-modal').css('display', 'flex');
    });

    $('.modal-close').on('click', function(e) {
      e.preventDefault();
      $('.sizeguide-modal').removeAttr('style');
    });

    $('.sizeguide-modal').on('click', function(e) {
      if ($(e.target).hasClass('sizeguide-modal')) {
        e.preventDefault();
        $('.sizeguide-modal').removeAttr('style');
      }
    });

    if ($('.moving-form').length) {
      // Show / Hide Add to Cart
      $(window).scroll(function(){
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        var elementTop = $(".shopify-product-form").offset().top;
        var elementBottom = elementTop + $(".shopify-product-form").outerHeight();

        if((elementBottom >= viewportTop) && (elementTop <= viewportBottom)){
          $(".moving-form").hide();
        } else {
          $(".moving-form").show();
        }
      });

      $('.moving-form .add_to_cart').on('click', function(e) {
        e.preventDefault();
        $('.product_form .add_to_cart').click();
      })

      $('.moving-ajax-submit').on('click', function(e) {
        e.preventDefault();
        $(this).attr('disabled', 'disabled').addClass('disabled');
        $(this).find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        $('.ajax-submit').click();
        $(this).find('.checkmark').addClass('checkmark-active');
        window.setTimeout(() => {
          $(this).removeAttr('disabled').removeClass('disabled');
          $(this).find('.checkmark').removeClass('checkmark-active');
          $(this).find('span').removeClass('zoomOut').addClass('fadeInDown');
        }, 1000);
      })
    }

    $('.toggleButton').on('click', function(e) {
      e.preventDefault();
      $('.read-more').toggle();
      $('.read-less').toggle();
      $(this).closest('.banner-with-content').toggleClass('dark-bg');
    });


    var resizeTimer;
    function handleResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            var targetHeight = $('.product_gallery').height();
            $('.product_gallery_nav.product-gallery__thumbnails').css('max-height', targetHeight);
        }, 500);
    }
    $(window).resize(handleResize);

    $(document).on('click', '#product-upsell, .content-area .close', function(e) {   
      if (e.target !== this)
      return;
      $('div#product-upsell').hide();
    });
  });
  
function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

  const observer = new MutationObserver(mutations => {
    if (document.querySelector(selector)) {
      observer.disconnect();
      resolve(document.querySelector(selector));
    }
  });

  observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

waitForElm('#cnc-container .btn').then((elm) => {
  $('#cnc-results-container #cnc-outlets').empty();
  setTimeout(function() {
    $('#cnc-container .btn').click();
  }, 500)
});

$('.cart-container .cart-close').on('click', function(e) {
  e.preventDefault();
  $('.cart-container').removeClass('active_link');
});

$('#open-cart, #open-cart-mobile').on('click', function(e) {
  e.preventDefault();
  $('#shopify-section-sidecart .cart-container').addClass('active_link');
});

$(function() {
  $('#checkEmail').on('submit', function(e) {
    e.preventDefault();
    $('.loading').css('display', 'flex');

    var email = $('#checkEmailValue').val();
    var settings = {
      "url": "https://cors-call.devotedigital.workers.dev/?https://ama-warehouse.myshopify.com/admin/api/2022-07/graphql.json",
      "method": "POST",
      "headers": {
        "X-Shopify-Access-Token": "cf292317297ba68eecf6ecc018b1c8e1",
        "Content-Type": "application/json",
      },
      "data": JSON.stringify({
        query: `{customers(first:1, query: "${email}") { edges { node { id tags } } } }`
      })
    };

    $.ajax(settings).done(function (response) {
      var edges = response.data.customers.edges[0];
      if(typeof edges === 'undefined') {
        $('#email-not-register').show();
        $('#email-register').hide();
        $('#customer_email').val(email);
        $('.loading').hide();
        $('.redirect_to').show();
        var numOfRiders = $('#ridersNumber').val();
        if(numOfRiders == 1) {
          $('#email-not-register input[name="customer[note][Mini Riders First Name 2]"]').prop('disabled', true);
          $('#email-not-register input[name="customer[note][Mini Riders Last Name 2]"]').prop('disabled', true);
          $('#email-not-register input[name="customer[note][Mini Riders DOB 2]"]').prop('disabled', true);
          $("#email-not-register select[name='customer[note][Mini Riders Shirt Size 2]']").prop('disabled', true);
          $('#email-not-register input[name="customer[note][Mini Riders First Name 3]"]').prop('disabled', true);
          $('#email-not-register input[name="customer[note][Mini Riders Last Name 3]"]').prop('disabled', true);
          $('#email-not-register input[name="customer[note][Mini Riders DOB 3]"]').prop('disabled', true);
          $("#email-not-register select[name='customer[note][Mini Riders Shirt Size 3]']").prop('disabled', true);
        }
        if(numOfRiders >= 2) {
          $('#email-not-register input[name="customer[note][Mini Riders First Name 2]"]').prop('disabled', false);
          $('#email-not-register input[name="customer[note][Mini Riders Last Name 2]"]').prop('disabled', false);
          $('#email-not-register input[name="customer[note][Mini Riders DOB 2]"]').prop('disabled', false);
          $("#email-not-register select[name='customer[note][Mini Riders Shirt Size 2]']").prop('disabled', false);
          
        }
        if(numOfRiders == 3) {
          $('#email-not-register input[name="customer[note][Mini Riders First Name 3]"]').prop('disabled', false);
          $('#email-not-register input[name="customer[note][Mini Riders Last Name 3]"]').prop('disabled', false);
          $('#email-not-register input[name="customer[note][Mini Riders DOB 3]"]').prop('disabled', false);
          $("#email-not-register select[name='customer[note][Mini Riders Shirt Size 3]']").prop('disabled', false);
        }
      }
      else {
        $('#email-register').show();
        $('#email-not-register').hide();
        $('.loading').hide();
        $('.redirect_to').show();
      }
    });
    $('#checkEmail').hide();
  });

  $('select[name="customer[note][Number of Mini Riders]"]').on('change', function() {

    if($(this).val() == 1) {
      $('.child-container.child-1').css('display', 'flex');
      $('.child-container.child-2').hide();
      $('.child-container.child-3').hide();
      $('#email-not-register input[name="return_to"]').val('/cart/39492057727048:1?channel=buy_button');
    }
    else if($(this).val() == 2) {
      $('.child-container.child-1').css('display', 'flex');
      $('.child-container.child-2').css('display', 'flex');
      $('.child-container.child-3').hide();
      $('#email-not-register input[name="return_to"]').val('/cart/39492057727048:2?channel=buy_button');
    }
    else if($(this).val() == 3) {
      $('.child-container.child-1').css('display', 'flex');
      $('.child-container.child-2').css('display', 'flex');
      $('.child-container.child-3').css('display', 'flex');
      $('#email-not-register input[name="return_to"]').val('/cart/39492057727048:3?channel=buy_button');
    }
  });

  $('#mini-rider').on('submit', function(e) {
    e.preventDefault();
    var email = $('#checkEmailValue').val();
    var settings = {
      "url": "https://cors-call.devotedigital.workers.dev/?https://ama-warehouse.myshopify.com/admin/api/2022-07/graphql.json",
      "method": "POST",
      "headers": {
        "X-Shopify-Access-Token": "cf292317297ba68eecf6ecc018b1c8e1",
        "Content-Type": "application/json",
      },
      "data": JSON.stringify({
        query: `{customers(first:1, query: "${email}") { edges { node { id tags note } } } }`
      })
    };

    $.ajax(settings).done(function (response) {
      var edges = response.data.customers.edges[0];
      var id = edges.node.id;
      var tags = edges.node.tags;
      var notes = edges.node.note;

      tags.push('minirider');

      var numOfRiders = $('#ridersNumber').val();
      var riderOneFname = $('#mini-rider input[name="customer[note][Mini Riders First Name 1]"]').val();
      var riderOneLname = $('#mini-rider input[name="customer[note][Mini Riders Last Name 1]"]').val();
      var riderOneDob = $('#mini-rider input[name="customer[note][Mini Riders DOB 1]"]').val();
      var riderOneShirt = $("#mini-rider select[name='customer[note][Mini Riders Shirt Size 1]']").val();

      var notePayload = notes + ' \r\n';
      notePayload += 'Mini Rider First Name: ' + riderOneFname + ' \r\n';
      notePayload += 'Mini Rider Last Name: ' + riderOneLname + ' \r\n';
      notePayload += 'Mini Rider Date of Birth: ' + riderOneDob + ' \r\n';
      notePayload += 'Mini Rider Shirt Size: ' + riderOneShirt + ' \r\n';

      if(numOfRiders >= 2) {
        var riderTwoFname = $('#mini-rider input[name="customer[note][Mini Riders First Name 2]"]').val();
        var riderTwoLname = $('#mini-rider input[name="customer[note][Mini Riders Last Name 2]"]').val();
        var riderTwoDob = $('#mini-rider input[name="customer[note][Mini Riders DOB 2]"]').val();
        var riderTwoShirt = $("#mini-rider select[name='customer[note][Mini Riders Shirt Size 2]']").val();
        
        notePayload+= ' \r\n';
        notePayload += 'Mini Rider First Name: ' + riderTwoFname + ' \r\n';
        notePayload += 'Mini Rider Last Name: ' + riderTwoLname + ' \r\n';
        notePayload += 'Mini Rider Date of Birth: ' + riderTwoDob + ' \r\n';
        notePayload += 'Mini Rider Shirt Size: ' + riderTwoShirt + ' \r\n';
      }
      if(numOfRiders == 3) {
        var riderThreeFname = $('#mini-rider input[name="customer[note][Mini Riders First Name 3]"]').val();
        var riderThreeLname = $('#mini-rider input[name="customer[note][Mini Riders Last Name 3]"]').val();
        var riderThreeDob = $('#mini-rider input[name="customer[note][Mini Riders DOB 3]"]').val();
        var riderThreeShirt = $("#mini-rider select[name='customer[note][Mini Riders Shirt Size 3]']").val();

        notePayload+= ' \r\n';
        notePayload += 'Mini Rider First Name: ' + riderThreeFname + ' \r\n';
        notePayload += 'Mini Rider Last Name: ' + riderThreeLname + ' \r\n';
        notePayload += 'Mini Rider Date of Birth: ' + riderThreeDob + ' \r\n';
        notePayload += 'Mini Rider Shirt Size: ' + riderThreeShirt + ' \r\n';
      }
      
      var variables = {input:{"id": id,"note": notePayload, "tags": tags}};

      var settings = {
        "url": "https://cors-call.devotedigital.workers.dev/?https://ama-warehouse.myshopify.com/admin/api/2022-07/graphql.json",
        "method": "POST",
        "timeout": 0,
        "headers": {
          "X-Shopify-Access-Token": "cf292317297ba68eecf6ecc018b1c8e1",
          "Content-Type": "application/json",
        },
        "data": JSON.stringify({
          query: "mutation customerUpdate($input: CustomerInput!) {\r\n  customerUpdate(input: $input) {\r\n    customer {\r\n      email\r\n      id\r\n    }\r\n    userErrors {\r\n      field\r\n      message\r\n    }\r\n  }\r\n}",
          variables: variables
        })
      };
      $.ajax(settings).done(function (response) {
          window.location.href = `/cart/39492057727048:${numOfRiders}?channel=buy_button`;
      });
    });
  });

  $('#email-not-register #create_customer').on('submit', function(e) {
    e.preventDefault();

    var settings = {
      "url": "/account",
      "method": "POST",
      "data": $(this).serialize(),
    };
    $.ajax(settings).done(function (response) {
      
    })
  })
})

$('.jdgm-prev-badge').on('click', function(e) {
  e.preventDefault();
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#review-tab").offset().top
  }, 1500, function() {
    $('#review-tab button').click();
  });
});


$(window).on('load', function() {
  $('.nav-desktop__tier-1-item').mouseover(function() {
    $(this).closest('.main-nav').addClass('hovered');
  }).mouseout(function() {
    $(this).closest('.main-nav').removeClass('hovered');
  });
})

if (window.PXUTheme.media_queries.large.matches) {
  $('.product-wrap').off().on('mouseenter', function() {
    $(this).find('.product-sizes').toggleClass('show-size');
  });

  $('.product-wrap').on('mouseleave', function() {
    $(this).find('.product-sizes').toggleClass('show-size');
  });
}

// Combo Products
$(function() {
  $(document).on('change', '#variant-sku .combo-dropdown select', function() {
    var price_container = $('.combo-price span');
    var compare_at_price_container = $('.combo-compare_at_price span');
    var option1 = $('#variant-sku .combo-dropdown #combo-form-0 option:selected');
    var option2 = $('#variant-sku .combo-dropdown #combo-form-1 option:selected');

    var option1Price = parseFloat(option1.data('price') * 100);
    var option2Price = parseFloat(option2.data('price') * 100);
    var option1ComparePrice = parseFloat(option1.data('compare') * 100);
    var option2ComparePrice = parseFloat(option2.data('compare') * 100);

    if (isNaN(option1Price)) {
      option1Price = 0;
    }
    if (isNaN(option2Price)) {
      option2Price = 0;
    }
    if (isNaN(option1ComparePrice)) {
      option1ComparePrice = 0;
    }
    if (isNaN(option2ComparePrice)) {
      option2ComparePrice = 0;
    }

    var newPrice = window.Shopify.formatMoney(option1Price + option2Price, $('body').data('money-format'));
    var newCompareAtPrice = window.Shopify.formatMoney(option1ComparePrice + option2ComparePrice, $('body').data('money-format'));
    price_container.text(newPrice);
    compare_at_price_container.text(newCompareAtPrice);

    $('#popup-variant-sku .combo-dropdown #combo-form-0').val(option1.val());
    $('#popup-variant-sku .combo-dropdown #combo-form-1').val(option2.val());
  });

  $(document).on('change', '#popup-variant-sku .combo-dropdown select', function() {
    var price_container = $('#popup-variant-sku .combo-price span');
    var compare_at_price_container = $('#popup-variant-sku.combo-compare_at_price span');

    var option1 = $('#popup-variant-sku .combo-dropdown #combo-form-0 option:selected');
    var option2 = $('#popup-variant-sku .combo-dropdown #combo-form-1 option:selected');
    
    var option1Price = parseFloat(option1.data('price') * 100);
    var option2Price = parseFloat(option2.data('price') * 100);
    var option1ComparePrice = parseFloat(option1.data('compare') * 100);
    var option2ComparePrice = parseFloat(option2.data('compare') * 100);

    if (isNaN(option1Price)) {
      option1Price = 0;
    }
    if (isNaN(option2Price)) {
      option2Price = 0;
    }
    if (isNaN(option1ComparePrice)) {
      option1ComparePrice = 0;
    }
    if (isNaN(option2ComparePrice)) {
      option2ComparePrice = 0;
    }

    var newPrice = window.Shopify.formatMoney(option1Price + option2Price, $('body').data('money-format'));
    var newCompareAtPrice = window.Shopify.formatMoney(option1ComparePrice + option2ComparePrice, $('body').data('money-format'));

    price_container.text(newPrice);
    compare_at_price_container.text(newCompareAtPrice);

    $('.combo-dropdown #combo-form-0').val(option1.val());
    $('.combo-dropdown #combo-form-1').val(option2.val());
  });

  $(document).on('click', '#popup-variant-sku #combo-submit', function() {
    $('#printing-popup [data-step="1"]').hide();
    $('#printing-popup [data-step="2"]').hide();
    $('#printing-popup [data-step="3"]').show();
  });
})

$(function() {
  var img = $('#vendor-icon');

  function checkImageStatus() {
    img.on('load', function() {
      $('#collection-image-container').show();
      img.show();
    }).on('error', function() {
      $('#collection-image-container').hide();
    });

    if (img[0].complete) {
      if (img[0].naturalWidth > 0) {
        img.trigger('load');
      } else {
        img.trigger('error');
      }
    }
  }

  checkImageStatus();
});

let hasClicked = false;
function openReviewTab() {
  if (window.location.search.includes('judgeme_token') || window.location.hash.includes('judgeme')) {
    const $reviewElement = $('#judgeme_product_reviews');
    if ($reviewElement.length) {
      if (!hasClicked) {
        const $button = $('#review-tab button');

        if ($button.length) {
          $('html, body').animate({ scrollTop: $button.offset().top }, 500, function() {
            $button.click();
          });
          hasClicked = true;
        }
      }
    }
  }
}

$(window).on('load', function() {
  if (typeof openReviewTab === 'function') {
    openReviewTab();
  }
});


$(function() {
  var maxHeight = -1;   
  $('.product-grid-item').each(function() { 
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height(); 
  });

  $('.product-grid-item').each(function() { 
    $(this).height(maxHeight);
  });
});

$(window).on('resize', function() {
  var maxHeight = -1;   
  $('.product-grid-item').removeAttr('style');   
  $('.product-grid-item').each(function() { 
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height(); 
  });

  $('.product-grid-item').each(function() { 
    $(this).height(maxHeight);
  });
});